import React, { useState, lazy } from 'react';
import { Section } from './ui/Section';
import { Button } from './ui/Button';
import { OrderBump } from './OrderBump';
import { motion } from 'framer-motion';
import { trackAddToCart } from './MetaPixel';
const URL_MAIN = 'https://ebookpromax.com/cart/add?id=46800282878110&quantity=1';
const URL_WITH_BUMP = 'https://ebookpromax.com/cart/add?id=46800283500702&quantity=1';
export function BonusStack() {
  const [bumpChecked, setBumpChecked] = useState(false);
  const bonuses = [{
    id: 1,
    title: 'Ensaladas en Frasco',
    subtitle: 'Meal Prep Argentino para Mujeres +40',
    value: '$14.990',
    desc: 'Ahorrás 5 horas de cocina por semana y $15.000/mes en delivery. 30 recetas balanceadas que preparás el domingo.',
    image: 'https://cdn.magicpatterns.com/uploads/nvmTAVGALmw1cnjaEGSmVy/PORTADA_BONO_1.png'
  }, {
    id: 2,
    title: 'Jugos Regenerativos',
    subtitle: '25 Recetas Funcionales para Piel y Energía',
    value: '$9.990',
    desc: 'Boost de vitaminas en 5 minutos. Más energía sin cafeína. Ingredientes de verdulerías argentinas.',
    image: 'https://cdn.magicpatterns.com/uploads/fHFkHzLUBwYyPQLkJcvwkA/PORTADA_BONO_2.png'
  }, {
    id: 3,
    title: 'Tracker de Hábitos',
    subtitle: 'Planilla Excel Interactiva 90 Días',
    value: '$12.990',
    desc: 'Sistema de tracking visual que convierte tus hábitos en datos (y los datos en motivación). Accountability real.',
    image: 'https://cdn.magicpatterns.com/uploads/vbrPyaaqwfAvJFWgxJvvMW/portada_bono_3.png'
  }, {
    id: 4,
    title: 'Protocolo de Suplementación',
    subtitle: 'Qué Tomar, Cuándo y Por Qué',
    value: '$14.990',
    desc: 'El único protocolo científico que te dice EXACTAMENTE qué suplementar según tu edad. Marcas argentinas.',
    image: 'https://cdn.magicpatterns.com/uploads/43NSr2pzHj11Yh7evy6t5p/PORTADA_BONO_4.png'
  }];
  const totalPrice = bumpChecked ? '$22.980' : '$17.990';
  const ctaUrl = bumpChecked ? URL_WITH_BUMP : URL_MAIN;
  const ctaLabel = bumpChecked ? `Quiero todo + Rituales por ${totalPrice}` : `Quiero todo el sistema por ${totalPrice}`;
  return <Section bg="olive-deep" id="precio" data-id="element-109">
      <div className="text-center mb-10 md:mb-20" data-id="element-110">
        <p className="text-xs font-medium tracking-[0.2em] text-gold uppercase mb-6" data-id="element-111">
          Oferta Exclusiva
        </p>
        <h2 className="text-4xl md:text-6xl font-serif text-cream-light mb-6" data-id="element-112">
          Además del Método...
        </h2>
        <p className="text-xl text-gold font-light italic" data-id="element-113">
          Llevás 4 Bonuses Exclusivos (Solo para las Primeras 500 Personas)
        </p>
      </div>

      <div className="max-w-5xl mx-auto" data-id="element-114">
        {/* Stack Summary Box */}
        <div className="bg-white/5 backdrop-blur-md border border-white/10 rounded-[2.5rem] p-8 md:p-12 mb-10 md:mb-16 relative overflow-hidden" data-id="element-115">
          <div className="absolute top-0 right-0 w-64 h-64 bg-gold/10 rounded-full blur-3xl" data-id="element-116" />

          <div className="relative z-10 space-y-6" data-id="element-117">
            <div className="flex flex-col md:flex-row justify-between items-start md:items-center border-b border-white/10 pb-6 gap-4" data-id="element-118">
              <div data-id="element-119">
                <p className="text-xs uppercase tracking-widest text-gold mb-1" data-id="element-120">
                  Ebook Principal
                </p>
                <h3 className="font-serif text-2xl text-cream-light" data-id="element-121">
                  Método Wellaging 360°
                </h3>
              </div>
              <div className="text-left md:text-right" data-id="element-122">
                <p className="line-through text-white/40 text-sm" data-id="element-123">$39.990</p>
                <p className="font-serif text-xl text-gold" data-id="element-124">$17.990</p>
              </div>
            </div>

            {bonuses.map(bonus => <div key={bonus.id} className="flex flex-col md:flex-row justify-between items-start md:items-center border-b border-white/10 pb-6 gap-4" data-id="element-125">
                <div data-id="element-126">
                  <p className="text-xs uppercase tracking-widest text-gold/60 mb-1" data-id="element-127">
                    Bonus 0{bonus.id}
                  </p>
                  <h3 className="font-serif text-xl text-cream-light mb-1" data-id="element-128">
                    {bonus.title}
                  </h3>
                  <p className="text-sm font-light text-white/60" data-id="element-129">
                    {bonus.subtitle}
                  </p>
                </div>
                <div className="text-left md:text-right shrink-0" data-id="element-130">
                  <p className="line-through text-white/40 text-sm" data-id="element-131">
                    {bonus.value}
                  </p>
                  <p className="font-medium text-olive-light uppercase tracking-widest text-xs" data-id="element-132">
                    Gratis Incluido
                  </p>
                </div>
              </div>)}

            <div className="pt-8 mt-8" data-id="element-133">
              <div className="bg-gold/10 border border-gold/20 rounded-2xl p-6 md:p-8 flex flex-col md:flex-row justify-between items-center gap-6 text-center md:text-left" data-id="element-134">
                <div data-id="element-135">
                  <p className="text-white/60 font-light mb-2" data-id="element-136">
                    Valor Total: <span className="line-through" data-id="element-137">$92.950</span>
                  </p>
                  <p className="text-4xl font-serif text-cream-light" data-id="element-138">
                    Hoy: <span className="text-gold" data-id="element-139">{totalPrice}</span>
                  </p>
                </div>
                <div className="bg-gold text-charcoal px-6 py-3 rounded-full font-medium text-sm tracking-wide" data-id="element-140">
                  Ahorrás $74.960 (81% OFF)
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Detailed Bonus Cards - Grid with images */}
        <div className="grid md:grid-cols-2 gap-6 md:gap-8" data-id="element-141">
          {bonuses.map((bonus, idx) => <motion.div key={bonus.id} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.1
        }} className="bg-white/5 border border-white/10 rounded-3xl overflow-hidden hover:bg-white/10 transition-colors group" data-id="element-142">
              <div className="aspect-square w-full overflow-hidden bg-cream-dark/30" data-id="element-143">
                <img src={bonus.image} alt={`${bonus.title} - Portada`} width={500} height={500} loading="lazy" decoding="async" className="w-full h-full object-cover group-hover:scale-[1.02] transition-transform duration-700" data-id="element-144" />
              </div>

              <div className="p-8" data-id="element-145">
                <p className="text-xs uppercase tracking-widest text-gold mb-3" data-id="element-146">
                  Bonus 0{bonus.id}
                </p>
                <h3 className="text-2xl font-serif text-cream-light mb-2" data-id="element-147">
                  {bonus.title}
                </h3>
                <p className="text-olive-light font-medium text-sm mb-5" data-id="element-148">
                  {bonus.subtitle}
                </p>
                <p className="text-white/70 font-light text-sm leading-relaxed mb-6" data-id="element-149">
                  {bonus.desc}
                </p>

                <div className="flex items-center justify-between pt-4 border-t border-white/10" data-id="element-150">
                  <p className="line-through text-white/40 text-sm" data-id="element-151">
                    Valor: {bonus.value}
                  </p>
                  <p className="text-gold font-medium uppercase tracking-widest text-xs" data-id="element-152">
                    Gratis Hoy
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>

        {/* Order Bump - inside pricing section */}
        <OrderBump isChecked={bumpChecked} onToggle={() => setBumpChecked(!bumpChecked)} data-id="element-153" />

        <div className="mt-8 md:mt-12 text-center" data-id="element-154">
          <Button href={ctaUrl} onClick={() => trackAddToCart({
          value: bumpChecked ? 22980 : 17990,
          contentName: bumpChecked ? 'Wellaging Argentino + Rituales de Bienestar' : 'Wellaging Argentino - Método 360°',
          contentId: bumpChecked ? 'wellaging-argentino-360-bundle' : 'wellaging-argentino-360'
        })} className="text-xl" subtext="Acceso Inmediato + Todos los Bonuses" data-id="element-155">
            {ctaLabel}
          </Button>
        </div>

        {/* MercadoLider Trust Badge */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mt-10 md:mt-16 max-w-2xl mx-auto" data-id="element-156">
          <div className="bg-white rounded-3xl overflow-hidden shadow-2xl border border-gold/10" data-id="element-157">
            <img src="https://cdn.magicpatterns.com/uploads/sbcHMAas4YoXmjirfEMUtG/MERCADOLIDER.jpg" alt="Pago seguro garantizado · MercadoLíder Platinum" width={800} height={400} loading="lazy" decoding="async" className="w-full h-auto block" data-id="element-158" />
          </div>
          <p className="text-center text-xs uppercase tracking-widest text-gold/70 mt-6 font-medium" data-id="element-159">
            Vendedor verificado · Pago 100% seguro
          </p>
        </motion.div>
      </div>
    </Section>;
}